import styled from 'styled-components';

export const Wrapper = styled.div`
  /* background-color: pink; */
  margin-top: 40px;
`;
export const MenuContainer = styled.div`
  flex-direction: row;
  flex-wrap: wrap;
`;
export const MenuWrapper = styled.div`
  /* background-color: mistyrose; */
  margin-left: 20px;
  margin-right: 20px;

  align-items: left;
  display: flex;
  flex-direction: column;
`;
export const MenuImg = styled.div`
  /* background-color: lavenderblush; */
  width: 400px;
  height: 300px;
`;
export const TextWrapper = styled.div`
  margin-top: 18px;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  text-align: left !important;
  /* align-items: center; */
  align-items: left !important;
  color: #fff;
`;
export const MenuName = styled.div`
  font-weight: 700;
  font-size: 17px;
  line-height: 20px;
  letter-spacing: 0.2px;
  align-items: left;
`;
export const MenuKcal = styled.div`
  margin-top: 4px;
  margin-bottom: 20px;
  /* padding-left: 10px; */
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  align-items: right;
`;
export const Menu = styled.div`
  width: 980px;
  display: flex;

  /* flex: auto; */
`;
